window.customElements.define('countdown-timer',
  class CountdownTimer extends HTMLElement {
    connectedCallback() {
      this.timer = null;
      this.interval = null;

      this.timer = this.querySelector('[data-timer]');
      const { year, month, day } = this.dataset;
      this.endDate = new Date(year, month - 1, day);

      this.startTimer();
    }

    disconnectedCallback() {
      this.stopTimer();
    }

    startTimer() {
      this.updateTimer();
      this.interval = setInterval(() => this.updateTimer(), 1000);
    }

    stopTimer() {
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
    }

    updateTimer() {
      const now = new Date();
      const distance = this.endDate - now;

      if (distance < 0) {
        this.stopTimer();
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      this.timer.textContent = `${days}d : ${hours}h : ${minutes}m : ${seconds}s`;
    }
  });